export enum Module {
  ClassDetail = "ClassDetail", // should we normalize or keep the same as legacy?
  ClassPlayer = "class_player",
  Settings = "settings",
  CheckoutMain = "CheckoutMain",
  CheckoutOffer = "CheckoutOffer",
  PlaylistDetails = "playlist_details",
  MyPlaylists = "my_playlists",
  SteezyPlaylists = "steezy_playlists",
  FollowedPlaylists = "followed_playlists",
  ProgramDetail = "ProgramDetail",
  Classes = "classes",
  Programs = "programs",
  Onboarding = "onboarding",
  CreatePlaylist = "create_playlist",
  Account = "account",
  SearchPrograms = "search_programs",
  SearchClasses = "search_classes",
  Community = "community",
  History = "history",
  Saved = "saved",
  Rewind = "rewind",
  Profile = "profile",
  CommunityFeed = "community_feed",
  CommunityGuidelines = "community_guidelines",
  ChallengeDetail = "challenge_detail",
  MyProfile = "my_profile",
  ChallengePost = "challenge_post",
  NavigationBar = "navigation_bar",
  SetupPin = "setup_pin",
  ModeSelection = "mode_selection",
  UpdatePin = "update_pin",
  DisablePin = "disable_pin",
  AddClassesModal = "add_classes_modal",
  UserVideoModal = "user_video_modal",
  UserVideoPost = "user_video_post",
}

export enum Container {
  SavedClasses = "saved_classes",
  SavedPrograms = "saved_programs",
  InstructorDetails = "instructor_details",
  Classes = "classes",
  Programs = "programs",
  ClassResults = "class_results",
  HistoryClasses = "history_classes",
  HistoryPrograms = "history_programs",
  ProgramDetailsRelated = "program_details_related",
  ClassDetailsSimilarClasses = "class_details_similar_classes",
  ClassDetailsInstructorClasses = "class_details_instructor_classes",
  CategoryNewClasses = "category_new_classes",
}

export enum ContentType {
  Class = "class",
  Program = "program",
  Playlist = "playlist",
  Video = "video",
  Comment = "comment",
}

export enum Location {
  AvatarDropdown = "avatar_dropdown",
  Community = "community",
  Library = "library",
  Home = "home",
  Search = "search",
  Account = "account",
  Saved = "saved",
  History = "history",
  Launch = "launch",
  Onboarding = "onboarding",
  Profile = "profile",
  Playlists = "playlists",
  Achievements = "achievements",
}

export enum ElementType {
  Button = "button",
  ClassCard = "class_card",
  ProgramCard = "program_card",
  ContentCard = "content_card",
  ListElement = "list_element",
  FeaturedClassCard = "featured_class_card",
  Toggle = "toggle",
  Icon = "icon",
  BottomSheet = "bottom_sheet",
}

export enum ElementName {
  AccountSubscription = "Account - Subscription",
  AccountDancePreferences = "Account - Dance Preferences",
  AccountManageAccount = "Account - Manage Account",
  AccountNotifications = "Account - Notifications",
  AccountManageData = "Account - Manage Your Data",
  AccountTermsOfService = "Account - Terms of Service",
  AccountPrivacyPolicy = "Account - Privacy Policy",
  AccountContactUs = "Account - Contact Us",
  LogOut = "Log Out",
  ShareContent = "Share Content",
  CloseButton = "Close Button",
  CheckoutPurchasePlanButton = "Checkout - Purchase Plan Button",
  CheckoutPurchasePlanOfferButton = "Checkout - Purchase Plan Offer Button",
  CheckoutViewOfferModal = "Checkout - View Offer Modal",
  PlaylistsCreatePlaylistButton = "Playlists - Create Playlist Button",
  PlaylistsAddClassesButton = "Playlists - Add Classes Button",
  CommunityReportComment = "Community Feed - Report Comment",
  CommunityReportVideo = "Community Feed - Report Video",
  OnboardingNotificationPermissions = "Onboarding - Notification Permissions",
  OnboardingSetProfilePhoto = "Onboarding - Set Profile Photo",
}

export enum StreamMethod {
  MobileApp = "mobile_app",
  Web = "web",
  Chromecast = "chromecast",
  Airplay = "airplay",
}

export enum Method {
  ClickedButton = "clicked_button",
}

export enum Action {
  PlaylistsCreatePlaylist = "Playlists - Create Playlist",
  PlaylistsAddClass = "Playlists - Add Class",
  PlaylistsRemoveClass = "Playlists - Remove Class",
  PlaylistsEditPlaylistDetails = "Playlists - Edit Playlist Details",
  PlaylistsDeletePlaylist = "Playlists - Delete Playlist",
}

export enum AuthProvider {
  GOOGLE = "google",
  FACEBOOK = "facebook",
  EMAIL = "email",
  APPLE = "apple",
}
